module.exports = __webpack_public_path__ + "img/1-2.259fdd08.png";